import waitForCaptcha from '../modules/wait-for-captcha';

const initialize = () => {
    waitForCaptcha('#verify_email_with_password_form');
};

export default initialize;
